import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";

export default () => {
  const [showPassword, setShowPassword] = useState(true);
  let initialState = {
    email: "",
    password: "",
    company_name: "",
    company_address: "",
    company_website: "",
    company_rep_firstname: "",
    company_rep_lastname: "",
    phone_number: "",
    account_payable_firstname: "",
    account_payable_lastname: "",
    account_payable_email: "",
    account_payable_phone_number: "",
    access_email: "",
    not_access_email: "",
    not_access_role: "",
    access_role: "",
  };
  const roleInitialState = {
    accessRole: "",
    notAccessRole: "",
  };
  const [advertise, setAdvertise] = useState(initialState);
  const [role, setRole] = useState(roleInitialState);
  console.log(role, "role");
  console.log(advertise, "hytr");

  const handleRole = (key, value) => {
    setRole({ ...role, [key]: value });
  };
  const handleChange = (key, value) => {
    setAdvertise({
      ...advertise,
      [key]: value,
      access_role: role?.accessRole,
      not_access_email: role?.notAccessRole,
    });
  };
  const { request, loading, error } = useApi((advertise) =>
    apiClient.put("/advertiserAccount", advertise)
  );

  useEffect(() => {
    const fetch = async () => {
      const response = await apiClient.get("/advertiserAccount");
      const data = response.data;
      console.log(data, "test");
      setAdvertise(data);
    };

    fetch();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await request(advertise);
    if (!result.status === 200) {
      return toast.error("Error");
    } else {
      return toast.success("Account Successfully Created");
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content">
          <div className="p-4">
            <div className="site-content-body">
              <div className="input-fields">
                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Email">
                      Email
                    </label>
                    <input
                    autocomplete="new-password"
                      // value={advertise?.email}
                      type="email"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="Email"
                      name="email"
                      onChange={(e) => handleChange("email", e.target.value)}
                    />
                  </div>

                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="Password">
                      Password
                    </label>
                    <div className="position-relative d-flex align-items-center">
                      <input
                        // value={advertise?.password}
                        autocomplete="new-password"
                        type={showPassword ? "password" : "text"}
                        className="form-control m-1  px-2 py-1 pe-5 fs-4"
                        id="Password"
                        name="password"
                        onChange={(e) =>
                          handleChange("password", e.target.value)
                        }
                      />
                      <span
                        className="show-password"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i class="bi bi-eye-fill" />
                        ) : (
                          <i class="bi bi-eye-slash-fill"></i>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="company-name"
                    >
                      Company Name
                    </label>
                    <input
                      value={advertise?.company_name}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="company-name"
                      onChange={(e) =>
                        handleChange("company_name", e.target.value)
                      }
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="company-address"
                    >
                      Company Address
                    </label>
                    <input
                      value={advertise?.company_address}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="company-address"
                      onChange={(e) =>
                        handleChange("company_address", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="company-website"
                    >
                      Company Website
                    </label>
                    <input
                      value={advertise?.company_website}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="company-website"
                      onChange={(e) =>
                        handleChange("company_website", e.target.value)
                      }
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="company-rep">
                      Company Rep (First Name)
                    </label>
                    <input
                      value={advertise?.company_rep_firstname}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="company-rep"
                      onChange={(e) =>
                        handleChange("company_rep_firstname", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="last-company-rep"
                    >
                      Company Rep (Last Name)
                    </label>
                    <input
                      value={advertise?.company_rep_lastname}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="last-company-rep"
                      onChange={(e) =>
                        handleChange("company_rep_lastname", e.target.value)
                      }
                    />
                  </div>

                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="phone-number"
                    >
                      Phone Number
                    </label>
                    <input
                      value={advertise?.phone_number}
                      type="tel"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="phone-number"
                      onChange={(e) =>
                        handleChange("phone_number", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1" htmlFor="account-pay">
                      Accounts Payable (First Name)
                    </label>
                    <input
                      value={advertise?.account_payable_firstname}
                      type="tex t"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="account-pay"
                      onChange={(e) =>
                        handleChange(
                          "account_payable_firstname",
                          e.target.value
                        )
                      }
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="last-account-pay"
                    >
                      Accounts Payable (Last Name)
                    </label>
                    <input
                      value={advertise?.account_payable_lastname}
                      type="text"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="last-account-pay"
                      onChange={(e) =>
                        handleChange("account_payable_lastname", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="account-email"
                    >
                      Accounts Payable (Email)
                    </label>
                    <input
                      value={advertise?.account_payable_email}
                      type="email"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="account-email"
                      onChange={(e) =>
                        handleChange("account_payable_email", e.target.value)
                      }
                    />
                  </div>
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="account-pay-phone"
                    >
                      Accounts Payable (phone number)
                    </label>
                    <input
                      value={advertise?.account_payable_phone_number}
                      type="tel"
                      className="form-control m-1  px-2 py-1 fs-4"
                      id="account-pay-phone"
                      onChange={(e) =>
                        handleChange(
                          "account_payable_phone_number",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>

                <div className="row gap-1 gap-md-2 justify-content-between">
                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1 text-decoration-underline fw-bold fs-4">
                      Who has access?
                    </label>
                    <div className="d-flex align-items-center">
                      <input
                        value={advertise?.access_email}
                        type="email"
                        className="form-control m-1 w-50 py-2 fs-6"
                        onChange={(e) =>
                          handleChange("access_email", e.target.value)
                        }
                      />
                      <select
                        value={advertise?.access_role}
                        name
                        id
                        className="form-control m-1 w-25  py-2 fs-6"
                      >
                        <option value>Role</option>
                        <option
                          onChange={(e) =>
                            handleRole("access_role", "Super Admin")
                          }
                          value
                        >
                          Super Admin
                        </option>
                        <option
                          onChange={(e) =>
                            handleRole("access_role", "Administrator")
                          }
                          value
                        >
                          Administrator
                        </option>
                        <option
                          onChange={(e) => handleRole("access_role", "Viewer")}
                          value
                        >
                          Viewer
                        </option>
                      </select>
                      <span className="icon bg-white text-dark border border-1 border-secondary px-3 py-2 rounded-3 fs-5">
                        <i class="bi bi-person-plus-fill"></i>
                      </span>
                    </div>
                    <div className="w-25 mx-auto">
                      <hr className="hr" />
                    </div>
                    <div className="d-flex align-items-center">
                      <input
                        value={advertise?.not_access_email}
                        type="email"
                        className="form-control m-1 w-50 py-2 fs-6"
                        onChange={(e) =>
                          handleChange("not_access_email", e.target.value)
                        }
                      />
                      <select
                        value={advertise?.access_role}
                        name
                        id
                        className="form-control m-1 w-25  py-2 fs-6"
                      >
                        <option value>Role</option>
                        <option
                          onChange={(e) =>
                            handleRole("not_access_role", "Super Admin")
                          }
                          value
                        >
                          Super Admin
                        </option>
                        <option
                          onChange={(e) =>
                            handleRole("not_access_role", "Administrator")
                          }
                          value
                        >
                          Administrator
                        </option>
                        <option
                          onChange={(e) =>
                            handleRole("not_access_role", "Viewer")
                          }
                          value
                        >
                          Viewer
                        </option>
                      </select>
                      <span className="icon bg-white text-danger border border-1 border-secondary px-3 py-2 rounded-3 fs-4 fw-bold">
                        X
                      </span>
                    </div>
                  </div>

                  <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                    <label className="label blue-clr m-1 text-decoration-underline fw-bold fs-4">
                      Role Key:
                    </label>
                    <div className="role-key-box rounded-3 border border-secondary w-75 px-2 py-1 m-1">
                      <h6 className="fw-bold lh-base">Super Admin:</h6>
                      <p className="fs-6 lh-small">
                        The super admin can view/edit: account, Campaign,
                        schedule, invoices and settings.
                      </p>
                      <h6 className="fw-bold lh-base mt-1">Admin:</h6>
                      <p className="fs-6 lh-small">
                        The admin can view/edit: account, Campaign, schedule,
                        and invoices.
                      </p>
                      <h6 className="fw-bold lh-base mt-1">Viewer:</h6>
                      <p className="fs-6 lh-small">
                        The viewer can view: account, Campaign and schedule.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                <button
                  type="submit"
                  className="save-changes blue-clr p-3 fs-4 border-0"
                >
                  <span className="pe-2">Save Changes</span>
                  <FaCheck />
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
